import {
   ServiceProvidingLocation,
   ServiceProvidingLocationForCurrentPracticeQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';
import { OrderingMap, paginations } from '@dreryk/command-query-ws-client';

type UseServiceProvidingLocationForCurrentPracticeCqrsSearchOptions = {
   enabled: boolean;
   withRemovedLocations?: boolean;
   orderingMap?: OrderingMap<ServiceProvidingLocation>;
};

export const useServiceProvidingLocationForCurrentPracticeCqrsSearch = (
   options?: UseServiceProvidingLocationForCurrentPracticeCqrsSearchOptions
): UseCqrsQueryResult<ServiceProvidingLocation[]> => {
   return useCqrsSearch(
      () => {
         const query = new ServiceProvidingLocationForCurrentPracticeQuery();
         query.removed = Slot.emptyIfNull(options?.withRemovedLocations ? null : false);
         return query;
      },
      options?.orderingMap ? paginations.all<ServiceProvidingLocation>().orderedByMap(options.orderingMap) : undefined,
      {
         enabled: options?.enabled,
      }
   );
};
